import { AdresseList } from '@mairistem/adresses';

import type { AdresseType } from '@/types';

interface RegieAdresseListItemProps {
  adresse: AdresseType;
}

const RegieAdresseListItem = (props: RegieAdresseListItemProps) => {
  const { adresse } = props;

  // AdresseList.Item ne masque que 0 : un numéro absent (null) s'afficherait « null »
  return <AdresseList.Item adresse={{ ...adresse, numeroVoirie: adresse?.numeroVoirie ?? 0 }} />;
};

export default RegieAdresseListItem;
